module.exports = __webpack_public_path__ + "static/media/ic_update.364cd240.svg";